import {combineReducers} from 'redux'
import entities from './entities'
import router, * as fromRouter from './router'
import search, * as fromSearch from '../actions/search'
import form from 'redux-form/lib/reducer'

const rootReducer = combineReducers({
    entities,
    router,
    search,
    form,
});

export default rootReducer;

export const getRouterRedirect = state => fromRouter.getRedirect(state.router);

export const getIsSearchFetching = state => fromSearch.getIsFetching(state.search);
export const getSearchError = state => fromSearch.getError(state.search);
export const getSearchResults = state => fromSearch.getResults(state.search, state.entities);
export const getSearchResultCount = state => fromSearch.getResultCount(state.search);
export const getSearchPage = state => fromSearch.getPage(state.search);
export const getSearchLimitExceeded = state => fromSearch.getLimitExceeded(state.search);


// WEBPACK FOOTER //
// ./src/reducers/root.js